import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import IbanInput from './IbanInput';
import type { SchemaCreditRequestForm } from '../../../schemas/creditRequestForm.schema';
import type { RefinanceableLoanType } from '../../../types';
import { FormBooleanSegmentedControl } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormBooleanSegmentedControl';
import { FormTextInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormTextInput';

type Props = {
    name: `${RefinanceableLoanType}.${number}`;
    disabled: boolean;
};

export const RefinanceFields: React.FC<Props> = ({ disabled, name }) => {
    const { t } = useTranslation();
    const { control } = useFormContext<SchemaCreditRequestForm>();
    const abloesen = useWatch({ control, name: `${name}.abloesen` });

    return (
        <>
            <FormBooleanSegmentedControl
                control={control}
                id={`${name}.abloesen`}
                label={t('EXISTING_LOANS.LOAN_REPLACE')}
                disabled={disabled}
            />
            <FormTextInput
                control={control}
                id={`${name}.glaeubiger`}
                label={t('EXISTING_LOANS.LOAN_CREDITOR')}
                disabled={disabled}
            />
            {abloesen && (
                <>
                    <IbanInput name={name} shouldFetchExternal disabled={disabled} />
                    <FormTextInput
                        control={control}
                        id={`${name}.bic`}
                        label={t('EXISTING_LOANS.LOAN_BIC')}
                        disabled={disabled}
                    />
                </>
            )}
        </>
    );
};
